export default class AllergenDisplayEnum {
    static get DEFAULT() {
        return 'default';
    }

    static get EXTENDED() {
        return 'extended';
    }

    static get options() {
        return {
            DEFAULT: this.DEFAULT,
            EXTENDED: this.EXTENDED
        };
    }
}
